import { CSLocales } from '@websrc/Typings/ContentStack'
import { Organization, WithContext } from 'schema-dts'

export const buildOrganisationSchema = (
  siteUrl: string | undefined,
  locale: CSLocales
): WithContext<Organization> => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'LEGO Education',
  url: siteUrl ? `${siteUrl}/${locale}/` : `https://education.lego.com/${locale}/`,
  description:
    'LEGO® Education offers a range of playful, hands-on STEAM learning experiences based on its comprehensive learning system for students in early learning, primary and secondary education, as well as through after-school programs and competitions.',
  parentOrganization: {
    '@type': 'Organization',
    name: 'The LEGO Group',
  },
  logo: 'https://assets.education.lego.com/v3/assets/blt293eea581807678a/bltfd621d3446b2239d/62a71ead2680af59223340f2/LEGO-Education.png?bg-color=ffffff&locale=en-us',
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '800-362-4308',
      contactType: 'customer service',
      areaServed: 'US',
      availableLanguage: 'en',
    },
    {
      '@type': 'ContactPoint',
      telephone: '866-349-5346',
      contactType: 'technical support',
      areaServed: 'US',
      availableLanguage: 'en',
    },
  ],
  sameAs: [
    'https://www.linkedin.com/company/lego-education/',
    'https://www.instagram.com/legoeducation/',
    'https://twitter.com/LEGO_Education',
    'https://www.youtube.com/@LEGOEducation',
    'https://www.facebook.com/LEGOeducationOfficial/',
  ],
})
